import type { SVGProps } from 'react';
const SvgMailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={10} fill="none" {...props}>
    <path d="M12.6 0H1.4C.63 0 0 .563 0 1.25v7.494C0 9.438.63 10 1.4 10h11.2c.77 0 1.4-.562 1.4-1.256V1.25C14 .563 13.37 0 12.6 0M1.4.625h11.2a.6.6 0 0 1 .182.025L7 5.569 1.218.65A.6.6 0 0 1 1.4.625m11.9 8.119c0 .35-.315.631-.7.631H1.4c-.385 0-.7-.281-.7-.631V1.25a.4.4 0 0 1 .028-.156l6.034 5.131a.37.37 0 0 0 .476 0l6.034-5.131q.03.074.028.156z" />
  </svg>
);
export default SvgMailIcon;
